module.exports = __webpack_public_path__ + "static/media/Whofolio_on_mobile_3.3ebd6310.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/images/Whofolio_on_mobile_3.png
// module id = 165
// module chunks = 0